<template>
  <div v-loading="pageLoading">
    <div>
      <!-- 搜索 -->
      <el-form :inline="true"
               :model="formInline"
               class="demo-form-inline">
        <el-form-item label="分公司">
          <el-input v-model="formInline.regionNames"
                    placeholder="請輸入分公司"
                    clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="btn"
                     @click="onSubmit">搜尋</el-button>
          <el-button type="primary"
                     @click="add">新增</el-button>
        </el-form-item>
      </el-form>

      <!-- 表格 -->
      <template>
        <el-table ref="singleTable"
                  empty-text="暫無記錄"
                  :data="tableData"
                  style="width: 100%"
                  border
                  @sort-change="sort">
          <el-table-column type="index"
                           label="序號"
                           width="120"></el-table-column>
          <el-table-column property="regionName"
                           label="分公司"></el-table-column>
          <el-table-column property="creationTime"
                           sortable="custom"
                           label="創建時間"></el-table-column>
          <el-table-column label="操作"
                           width="145">
            <template slot-scope="scope">
              <el-button size="mini"
                         type="warning"
                         @click="edit(scope.row.regionName, scope.row.id)">編輯</el-button>
              <el-button size="mini"
                         type="danger"
                         @click="open(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <el-pagination :hide-on-single-page="true"
                     :total="total"
                     layout="prev, pager, next,total"
                     @current-change="pageChange"></el-pagination>

      <!-- 彈窗 -->
      <el-dialog :title="title"
                 :visible.sync="dialogFormVisible"
                 width="500px">
        <el-form>
          <el-form-item label="分公司"
                        :label-width="formLabelWidth">
            <el-input v-model="region"
                      placeholder="請輸入分公司名稱"
                      autocomplete="off"
                      maxlength="50"
                      @input="maxlengths(region)"
                      show-word-limit
                      style="width: 80%;"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer"
             class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary"
                     :loading="dialogLoading"
                     @click="regionM()">確 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
var that;
export default {
  data () {
    return {
      pageLoading: false,

      formInline: {
        regionNames: '',
        pageSize: 10,
        pageNum: 1,
        sortAsc: '',
        sortDesc: 'creationTime'
      },
      total: 0,
      region: '',
      regionId: '',
      formLabelWidth: '80px',
      tableData: [],
      dialogFormVisible: false,
      title: '',
      isEdit: false, //是否是修改

      dialogLoading: false
    };
  },
  mounted () {
    $('#pageHead').text('分公司管理');
  },
  methods: {
    sort (msg) {
      var prop = msg.prop,
        order = msg.order,
        formInline = this.formInline;
      if (order == 'ascending') {
        formInline.sortDesc = prop;
        formInline.sortAsc = '';
      } else {
        formInline.sortDesc = '';
        formInline.sortAsc = prop;
      }
      that.loadMsg();
    },
    onSubmit () {
      that.formInline.pageNum = 1;
      that.loadMsg();
    },
    add () {
      // 新增
      this.title = '新增';
      this.isEdit = false;
      this.region = '';
      this.dialogFormVisible = true;
    },
    regionM () {
      if (this.region == '') {
        this.$message({
          type: 'warning',
          message: '請輸入分公司名字'
        });
        return;
      }
      this.dialogLoading = true
      if (this.isEdit) {
        // 修改
        this.axios({
          url: '/manage/updateManRegion',
          method: 'post',
          params: {
            regionName: this.region,
            id: this.regionId
          }
        }).then(res => {
          if (res) {
            this.$message({
              type: 'success',
              message: '修改成功!'
            });
            this.dialogFormVisible = false;
            this.dialogLoading = false
            // 更新vuex中region相关缓存
            this.$store.commit('commonData/setRegionList', [])
            this.$store.commit('commonData/setEchoDistrictBranchDepartmentList', [])
            this.$store.commit('commonData/setRelevanceList', [])
          }
          this.loadMsg();
        }).catch(() => {
          this.dialogLoading = false
        })
      } else {
        // 新增
        this.axios({
          url: '/manage/addManRegion',
          method: 'post',
          params: {
            regionName: this.region
          }
        }).then(res => {
          if (res) {
            this.$message({
              type: 'success',
              message: '新增成功!'
            });
            this.dialogFormVisible = false;
            this.dialogLoading = false
            // 更新vuex中region相关缓存
            this.$store.commit('commonData/setRegionList', [])
            this.$store.commit('commonData/setEchoDistrictBranchDepartmentList', [])
            this.$store.commit('commonData/setRelevanceList', [])
          }
          this.loadMsg();
        }).catch(() => {
          this.dialogLoading = false
        })
      }
    },
    maxlengths(reg){
      if(reg.length==50){
        this.$message({
          type: 'warning',
          message: '分公司名字最大长度为50字'
        });
      }
    },
    pageChange (val) {
      // 切換頁碼
      that.formInline.pageNum = val;
      that.loadMsg();
    },
    open (id) {
      this.$confirm('確認刪除該地区？', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '確定',
        type: 'warning'
      })
        .then(() => {
          this.axios({ url: '/manage/delManRegion', params: { id }, method: 'post' }).then(res => {
            if (res) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.loadMsg();
              // 更新vuex中region相关列表
              this.$store.commit('commonData/setRegionList', [])
              this.$store.commit('commonData/setEchoDistrictBranchDepartmentList', [])
              this.$store.commit('commonData/setRelevanceList', [])
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    edit (name, id) {
      this.title = '修改';
      this.region = name;
      this.regionId = id;
      this.isEdit = true;
      this.dialogFormVisible = true;
    },
    loadMsg () {
      this.pageLoading = true
      this.axios({
        url: '/manage/getManRegionList',
        params: that.formInline
      }).then(res => {
        this.tableData = res.result;
        this.total = res.total;
        this.pageLoading = false
      });
    }
  },
  created () {
    that = this;
    that.loadMsg();
  }
};
</script>

<style scoped>
.btn {
  margin-left: 20px;
}

.dialog-footer {
  display: flex;
  justify-content: space-around;
}

img {
  width: 100px;
}
</style>
